import { gql } from '@apollo/client';

export default class SMSQuery {
    static GET_SMS_BY_CRM_ID = gql`
        query getSMSByCRMId($paginate: SMSPaginate!, $crmId: ID!) {
            getSMSByCRMId(paginate: $paginate, crmId: $crmId) {
                totalCount
                data {
                    smsId
                    status
                    message
                    smsChatId
                    direction
                    createdOn
                    createdBy {
                        firstName
                        lastName
                        avatar
                    }
                    errorCode
                    attachments {
                        messageAttachmentId
                        fileName
                        mimeType
                        size
                        createdOn
                    }
                }
            }
        }
    `;

    static GET_MESSAGE_ATTACHMENT_UPLOAD_SIGNED_URL = gql`
        query getMessageAttachmentUploadSignedURL($crmId: ID!, $fileName: String!) {
            getMessageAttachmentUploadSignedURL(crmId: $crmId, fileName: $fileName) {
                url
                path
            }
        }
    `;

    static GET_MESSAGE_ATTACHMENT_SECURE_URL = gql`
        query getMessageAttachmentSecureURL($crmId: ID!, $fileName: String!) {
            getMessageAttachmentSecureURL(crmId: $crmId, fileName: $fileName)
        }
    `;
}
